import React, { useState } from "react";
import { Link } from "react-router-dom";

const LogoutPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleGoogleLogin = () => {
        window.location.href = `${window.REACT_APP_API_ENDPOINT}/auth/google?redirect=/listado`;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const res = await fetch(`${window.REACT_APP_API_ENDPOINT}/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ email, password }),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || "Email o contraseña incorrectos");
            window.location.href = "/listado";
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const inputClassName = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm";

    return (
        <div className="max-w-4xl mx-auto py-8">
            <div className="grid md:grid-cols-2 gap-0 rounded-2xl overflow-hidden shadow-xl">

                {/* Left — brand + goodbye */}
                <div className="bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white p-10 flex flex-col justify-between">
                    <div>
                        <span className="text-2xl font-bold tracking-tight">Reformista</span>
                        <p className="text-blue-200 text-sm mt-1">Análisis de inversión inmobiliaria</p>
                    </div>

                    <div className="my-10">
                        <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-6">
                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h1 className="text-3xl font-bold mb-3">¡Hasta pronto!</h1>
                        <p className="text-blue-200 text-base leading-relaxed">
                            Tu sesión se ha cerrado correctamente. Gracias por usar Reformista para analizar tus oportunidades de inversión.
                        </p>
                    </div>

                    <div className="space-y-3 text-sm text-blue-200">
                        <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>
                            Análisis ROI para reforma estándar y premium
                        </div>
                        <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
                            Comparativa alquiler, vacacional y venta
                        </div>
                        <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>
                            Análisis IA de estado y actuaciones
                        </div>
                    </div>
                </div>

                {/* Right — login form */}
                <div className="bg-white p-10 flex flex-col justify-center">
                    <h2 className="text-xl font-bold text-gray-900 mb-1">Volver a entrar</h2>
                    <p className="text-sm text-gray-500 mb-6">Inicia sesión para continuar donde lo dejaste.</p>

                    <button
                        onClick={handleGoogleLogin}
                        className="w-full flex items-center justify-center bg-[#4285F4] hover:bg-[#357ae8] text-white font-medium py-2.5 px-4 rounded-md shadow-sm mb-4 text-sm transition-colors"
                    >
                        <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google" className="h-4 w-4 mr-2 bg-white rounded-full" />
                        Continuar con Google
                    </button>

                    <div className="relative my-4">
                        <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-gray-200" /></div>
                        <div className="relative flex justify-center text-xs"><span className="bg-white px-3 text-gray-400">o con email</span></div>
                    </div>

                    {error && <div className="bg-red-50 text-red-600 p-3 rounded-md mb-4 text-sm">{error}</div>}

                    <form onSubmit={handleLogin} className="space-y-4">
                        <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">Email</label>
                            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClassName} placeholder="tu@email.com" />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">Contraseña</label>
                            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputClassName} />
                        </div>
                        <button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-md shadow-sm disabled:opacity-50 text-sm transition-colors">
                            {loading ? "Iniciando sesión..." : "Iniciar sesión"}
                        </button>
                    </form>

                    <div className="mt-4 flex justify-between text-xs text-gray-400">
                        <Link to="/login" className="hover:text-blue-600 hover:underline">¿Olvidaste tu contraseña?</Link>
                        <Link to="/login" className="hover:text-blue-600 hover:underline">Crear cuenta</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LogoutPage;
